// Small pill toggle for choosing "left" / "center" alignment for a text block.
// Used by SubmitPage, EditPostModal and SiteSettingsPanel to keep the affordance
// consistent across all text-editing surfaces.
export default function AlignmentToggle({ value, onChange, label = "Alignment when published", testidPrefix }) {
  const active = value === "center" ? "center" : "left";
  return (
    <div className="mt-3 flex items-center gap-3 flex-wrap">
      <span className="mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">{label}</span>
      <div className="flex gap-2" data-testid={testidPrefix}>
        {["left", "center"].map((opt) => (
          <button
            key={opt}
            type="button"
            data-testid={`${testidPrefix}-${opt}`}
            onClick={() => onChange(opt)}
            className={`mono text-[10px] uppercase tracking-[0.2em] px-3 py-1 border transition-colors ${
              active === opt
                ? "bg-black text-white border-black"
                : "border-neutral-300 hover:border-black"
            }`}
          >
            {opt === "left" ? "Left" : "Centre"}
          </button>
        ))}
      </div>
    </div>
  );
}
